import React, {Fragment, useState} from 'react';
import PartnerCameraCalibration from './partner-camera-calibration';
import {isFieldCopy, fieldCopyLabel} from '../util/field-copy';
import PartnerResourceNvrStatus, {useResourceNvrStatus} from './partner-resource-nvr-status';
import PropTypes from 'prop-types';
import {Button, Carousel, Fade, Container, Row, Col, Card, Image, Tab, Tabs} from 'react-bootstrap';
import {Redirect} from 'react-router-dom';
import CommonMetaTag from './common-meta-tag';
import Configuration from '../config';
import {SPORTS} from '../constants';
import coveredIcon from '../images/coperto-scoperto_campo.svg';
import terrainIcon from '../images/terreno_campo.svg';
import swimmingPoolIcon from '../images/terreno_piscina.svg';
import {useTranslation} from 'react-i18next';
import {newOwnedField, newOwnedService} from '../actions/partner';
import {FaCalendarAlt, FaCalendarPlus, FaConciergeBell, FaEdit, FaMapMarkedAlt, FaPlus, FaUsers} from 'react-icons/fa';

const PartnerFields = ({
  ownedFields,
  token,
  ownedServices,
  isLogged,
  showField,
  showService,
  profile,
  partnerFieldsActiveTab,
  showCalendar,
  showServiceCalendar,
  showBookingCalendar,
  showServiceBookingCalendar,
  setActiveTab,
  goto
}) => {
  const {t} = useTranslation();
  const [calibrationField, setCalibrationField] = useState(null);
  const nvr = useResourceNvrStatus(token, isLogged && partnerFieldsActiveTab === 'campi');
  const openMatchesEnabled = Boolean(profile && profile.openMatchesEnabled);
  if (!isLogged) {
    return (
      <Redirect to="/login"/>
    );
  }

  return (
    <Fragment>
      {calibrationField !== null && <PartnerCameraCalibration fieldId={calibrationField} token={token} onHide={() => setCalibrationField(null)}/>}
      <CommonMetaTag/>
      <Fade in appear style={{transition: 'opacity 0.30s linear', marginTop: 100}}>
        <Container className="partner-resources-page">
          <Row className="justify-content-center">
            <Col xs={12} sm={12} md={12}>
              <Row>
                <Col>
                  <div className="partner-resources-hero">
                    <span>Gestione risorse</span>
                    <h4>{t('RESOURCES')}</h4>
                    {partnerFieldsActiveTab === 'campi' && <Button variant="outline-secondary" size="sm" onClick={nvr.refresh}>Aggiorna stato</Button>}
                    <p>Organizza campi sportivi e servizi, quindi accedi rapidamente a modifica, prenotazione e pianificazione.</p>
                  </div>
                </Col>
              </Row>
              <Tabs activeKey={partnerFieldsActiveTab} className="myvideo-tabs partner-resources-tabs" onSelect={t => setActiveTab(t)}>
                <Tab eventKey="campi" title={<span><FaMapMarkedAlt aria-hidden="true"/> {t('FIELDS')}</span>} tabClassName="myvideo-tab">
                  <Row className="partner-resources-section-head">
                    <Col>
                      <p>{t('CREATE_AND_ADD_FIELDS')}</p>
                    </Col>
                    <Col className="partner-resource-head-actions">
                      {openMatchesEnabled ? (
                        <Button className="partner-resource-open-match" onClick={goto('/partner-open-matches/create')}><FaUsers aria-hidden="true"/> {t('CREATE_OPEN_MATCH')}</Button>
                      ) : null}
                      <Button className="partner-resource-add" onClick={goto('partner-field', newOwnedField)}><FaPlus aria-hidden="true"/> {t('ADD_FIELD')}</Button>
                    </Col>
                  </Row>
                  <Row className="partner-resources-grid">
                    {
                      ownedFields.map(f =>
                        (
                          <Col key={f.id} xs={12} sm={12} md={12} xl={6} lg={6}>
                            <Card className="partner-resource-card">
                              <Card.Body>
                                {
                                  f.imagesNames.length === 0 ?
                                    <Fragment>
                                      <div className="card sportcenter_card_bg_rp">
                                        <div className="card_image_rp">
                                          <div className="videoWrapper card_image_sportcenter_rp"/>
                                      </div>
                                    </div> 
                                    </Fragment> :
                                    <Carousel style={{marginBottom: 10}} interval={null}>
                                      {
                                        f.imagesNames.map(i =>
                                          (
                                            <Carousel.Item key={i}>
                                              <img
                                                className="d-block w-100"
                                                src={`${Configuration.apiEndPoint}/partners/fields/${f.id}/images?load=${i}`}
                                                alt={t('FIRST_SLIDE')}
                                                style={{width: '100%'}}
                                              />
                                            </Carousel.Item>
                                          )
                                        )
                                      }
                                    </Carousel>
                                }
                                <Card.Title className="partner-resource-card__title">
                                  <Row style={{marginBottom: 25, marginTop: 25}}>
                                    <Col xs={3} sm={3} md={3} xl={2} lg={2}>
                                      <Image
                                        style={{width: '80%'}}
                                        src={SPORTS[f.sport] ? SPORTS[f.sport].icon : null}
                                      />
                                    </Col>
                                    <Col>
                                      <Row style={{marginBottom: 10}}>{f.name}</Row>
                                      <Row><Card.Subtitle className="text-muted">{f.sport}</Card.Subtitle></Row>
                                    </Col>
                                  </Row>
                                </Card.Title>
                                <Card.Text className="partner-resource-card__description">
                                  {f.description}
                                  {isFieldCopy(f) && <span className="d-block text-info">{fieldCopyLabel(f)}</span>}
                                </Card.Text>
                                <Row className="partner-resource-card__features justify-content-center align-items-center">
                                  <Col xs={2} sm={2} md={2} xl={2} lg={2}>
                                    <Image
                                      style={{width: '100%', maxWidth: 50}}
                                      src={coveredIcon}
                                    />
                                  </Col>
                                  <Col>
                                    {f.covered ? t('COVERED_FIELD') : t('OPEN_FIELD')}
                                  </Col>
                                  <Col xs={2} sm={2} md={2} xl={2} lg={2}>
                                    <Image
                                      style={{width: '100%', maxWidth: 50}}
                                      src={f.terrain === 'Piscina' ? swimmingPoolIcon : terrainIcon}
                                    />
                                  </Col>
                                  <Col>
                                    {f.terrain}
                                  </Col>
                                </Row>
                                <PartnerResourceNvrStatus fieldId={f.id} status={nvr.fields[f.id]} error={nvr.error}/>
                                <div className="partner-nvr-calibration">
                                  <p>Calibrazione del campo: {f.partnerCalibrationEnabled ? 'abilitata dall’admin' : 'non abilitata dall’admin'}</p>
                                  {f.partnerCalibrationEnabled && !isFieldCopy(f) && <Button block variant="outline-primary" disabled={nvr.fields[f.id] && nvr.fields[f.id].online === false} onClick={() => setCalibrationField(f.id)}>Apri camera live</Button>}
                                </div>
                                <Row className="partner-resource-card__actions justify-content-center">
                                  <Col xs={12} sm={12} md={4} xl={4} lg={4} className="d-flex justify-content-center text-center">
                                    <Button block variant="outline-primary" size="lg" onClick={showField(f)}><FaEdit aria-hidden="true"/> {t('CHANGE')}</Button>
                                  </Col>
                                  <Col xs={12} sm={12} md={4} xl={4} lg={4} className="d-flex justify-content-center text-center">
                                    <Button block variant="outline-primary" size="lg" onClick={showBookingCalendar(f)}><FaCalendarPlus aria-hidden="true"/> {t('BOOK')}</Button>
                                  </Col>
                                  <Col xs={12} sm={12} md={4} xl={4} lg={4} className="d-flex justify-content-center text-center">
                                    <Button block variant="outline-primary" size="lg" onClick={showCalendar(f)}><FaCalendarAlt aria-hidden="true"/> {t('PLAN')}</Button>
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Card>
                          </Col>
                        )
                      )
                    }
                  </Row>
                </Tab>
                <Tab eventKey="servizi" title={<span><FaConciergeBell aria-hidden="true"/> {t('SERVICES')}</span>} tabClassName="myvideo-tab">
                  <Row className="partner-resources-section-head">
                    <Col>
                      <p>{t('CREATE_AND_ADD_SERVICES')}</p>
                    </Col>
                    <Col>
                      <Button className="partner-resource-add float-right" onClick={goto('partner-service', newOwnedService)}><FaPlus aria-hidden="true"/> {t('ADD_SERVICE')}</Button>
                    </Col>
                  </Row>
                  <Row className="partner-resources-grid">
                    {
                      ownedServices.map(s =>
                        (
                          <Col key={s.id} xs={12} sm={12} md={12} xl={6} lg={6}>
                            <Card className="partner-resource-card partner-resource-card--service">
                              <Card.Body>
                                {
                                  s.imagesNames && s.imagesNames.length === 0 ?
                                    <Fragment>
                                      <div className="card sportcenter_card_bg_rp">
                                        <div className="card_image_rp">
                                          <div className="videoWrapper card_image_sportcenter_rp"/>
                                      </div>
                                    </div> 
                                    </Fragment> :
                                    <Carousel style={{marginBottom: 10}} interval={null}>
                                      {
                                        (s.imagesNames || []).map(i =>
                                          (
                                            <Carousel.Item key={i}>
                                              <img
                                                className="d-block w-100"
                                                src={`${Configuration.apiEndPoint}/partners/services/${s.id}/images?load=${i}`}
                                                alt={t('FIRST_SLIDE')}
                                                style={{width: '100%'}}
                                              />
                                            </Carousel.Item>
                                          )
                                        )
                                      }
                                    </Carousel>
                                }
                                <Card.Title className="partner-resource-card__title">
                                  <Row style={{marginBottom: 25, marginTop: 25}}>
                                    <Col>
                                      <Row style={{marginBottom: 10, marginLeft: 0}}>{s.name}</Row>
                                      <Row style={{marginLeft: 0}}><Card.Subtitle className="text-muted">{s.briefDescription}</Card.Subtitle></Row>
                                    </Col>
                                  </Row>
                                </Card.Title>
                                <Card.Text className="partner-resource-card__description">
                                  {s.description}
                                </Card.Text>
                                <Row className="partner-resource-card__actions justify-content-center">
                                  <Col xs={12} sm={12} md={4} xl={4} lg={4} className="d-flex justify-content-center text-center">
                                    <Button block variant="outline-primary" size="lg" onClick={showService(s)}><FaEdit aria-hidden="true"/> {t('CHANGE')}</Button>
                                  </Col>
                                  <Col xs={12} sm={12} md={4} xl={4} lg={4} className="d-flex justify-content-center text-center">
                                    <Button block variant="outline-primary" size="lg" onClick={showServiceBookingCalendar(s)}><FaCalendarPlus aria-hidden="true"/> {t('BOOK')}</Button>
                                  </Col>
                                  <Col xs={12} sm={12} md={4} xl={4} lg={4} className="d-flex justify-content-center text-center">
                                    <Button block variant="outline-primary" size="lg" onClick={showServiceCalendar(s)}><FaCalendarAlt aria-hidden="true"/> {t('PLAN')}</Button>
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Card>
                          </Col>
                        )
                      )
                    }
                  </Row>
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Container>
      </Fade>
    </Fragment>
  );
};

PartnerFields.propTypes = {
  ownedFields: PropTypes.array,
  ownedServices: PropTypes.array,
  newField: PropTypes.func.isRequired,
  isLogged: PropTypes.bool,
  showField: PropTypes.func.isRequired,
  profile: PropTypes.object,
  partnerFieldsActiveTab: PropTypes.string,
  setActiveTab: PropTypes.func.isRequired,
  showCalendar: PropTypes.func.isRequired,
  showServiceCalendar: PropTypes.func.isRequired,
  showBookingCalendar: PropTypes.func.isRequired,
  showServiceBookingCalendar: PropTypes.func.isRequired,
  goto: PropTypes.func.isRequired
};

PartnerFields.defaultProps = {
  profile: null,
  partnerFieldsActiveTab: "campi",
  ownedFields: [],
  ownedServices: [],
  isLogged: false
};

export default PartnerFields;
